import PropTypes from 'prop-types';
import { useMemo } from 'react';
// @mui
import { CssBaseline } from '@mui/material';
import { ThemeProvider as MUIThemeProvider, createTheme, StyledEngineProvider } from '@mui/material/styles';
import { ThemeProvider as SIMThemeProvider, StylesProvider } from '@mui/styles';

// hooks
import useSettings from '../hooks/useSettings';

//
import shape from './shape';
import breakpoints from './breakpoints';

import GlobalStyles from './globalStyles';
import componentsOverride from './overrides';
import { themeCreator } from './base';


// ----------------------------------------------------------------------

ThemeProvider.propTypes = {
  children: PropTypes.node,
};

export default function ThemeProvider({ children }) {
  const { themeMode, themeDirection } = useSettings();

  const theme = themeCreator(themeMode);
  console.log('%c themeMode', 'color: red', theme, themeMode)

  // const isLight = themeMode === 'light';
  // const themeOptions = useMemo(
  //   () => ({
  //     breakpoints,
  //     palette,
  //     shape,
  //     typography,
  //     shadows: shadows(),
  //     customShadows: customShadows(),
  //     global,
  //   }),
  //   [isLight, themeDirection]
  // );
  // const theme = createTheme(themeOptions);
  theme.components = componentsOverride(theme);

  return (
    <StyledEngineProvider injectFirst>
      <SIMThemeProvider theme={theme}>
        <MUIThemeProvider theme={theme}>
          <CssBaseline />
          <GlobalStyles theme={theme} />
          {children}
        </MUIThemeProvider>
      </SIMThemeProvider>
    </StyledEngineProvider>
  );
}
